// @ts-check

// Vendor imports
const cookie = require('js-cookie')

// Version the `user_identified` cookie since sometimes we need to
// trigger users to re-identify after code-changes.
const USER_IDENTIFIED_VERSION = '6'

/**
 * @type {Object} Segment SDK
 * @prop {function} identify
 * @prop {function} page
 * @prop {function} track
 * @see https://segment.com/docs/sources/website/analytics.js/
 */
// @ts-ignore Assume that segment exists on the window object
const segmentSdk = typeof window === 'object' ? window.analytics : null

/**
 * A thin wrapper around Segment SDK's `identify` method
 * @param {Object} user
 * @see https://segment.com/docs/spec/identify/
 * @see https://segment.com/docs/sources/website/analytics.js/#identify
 */
async function identifyUser(user) {
  if (
    // The Segment SDK is sometimes blocked by the user-agent
    !segmentSdk ||
    // Logged-out users have a randomly-generated anonymous ID
    !user.loggedIn ||
    // Users that have already been identified do not need to be re-identified
    cookie.get('user_identified') === USER_IDENTIFIED_VERSION
  ) {
    return
  }

  // Convert providers Object to comma-separated keys string
  const providers = Object.keys(user.providers).join(',')

  // Convert experiments Object into a comma-separated key=value string
  const testGroups = Object.entries(user.experiments)
  .map(pair => pair.join('='))
  .join(',')

  segmentSdk.identify(user.id, {
    'access_granted_at': user['access_granted_at'],
    'birthday': user.birthday,
    'category': user.category,
    'created_at': user['created_at'],
    'display_name': user['display_name'],
    'email': user.email,
    'gender': user.gender,
    'name': user['display_name'],
    'providers': providers,
    'signup_context': user['signup_context'],
    'test_groups': testGroups,
    'username': user.username,
    'user_type': user['user_type']
  })

  cookie.set('user_identified', USER_IDENTIFIED_VERSION)
}


/**
 * A thin wrapper around Segment SDK's `track` method
 * @param {string} eventName
 * @param {Object} [properties]
 * @see https://segment.com/docs/spec/track/
 * @see https://segment.com/docs/sources/website/analytics.js/#track
 */
async function track(eventName, properties) {
  if (!segmentSdk) {
    return
  }
  segmentSdk.track(eventName, properties)
}

/**
 * A thin wrapper around Segment SDK's `page` method
 * @param {string} pageName
 * @param {Object} [properties]
 * @see https://segment.com/docs/spec/page/
 * @see https://segment.com/docs/sources/website/analytics.js/#page
 */
async function page(pageName, properties = {}) {
  if (!segmentSdk) {
    return
  }
  segmentSdk.page(pageName, properties)
}

module.exports = {
  identifyUser,
  track,
  page
}
